import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";

const NextStep = (props: any) => {
    return (
        <Fragment>
            <li>
                <div className="dashboard-alert-container status-info">
                    <Link onClick={() => window.addToDataLayer({ event: props.flowStepName })} to={props.navigationPath}>
                        <span className="row">
                            <span className="col-xs col-no-gutter flex-grow-null">
                                <span className="dashboard-alert-icon">
                                    <RenderIcons iconName="info-circle" />
                                </span>
                            </span>
                            <span className="col-xs col-no-gutter">
                                <span className="dashboard-alert-description">
                                    <span className="sr-only">Informative Alert:</span>
                                    {" " + props.flowStepName}
                                </span>
                            </span>
                        </span>
                    </Link>
                </div>
            </li>
        </Fragment>
    );
};

export default NextStep;
